/* eslint-disable react/no-array-index-key */
import clsx from 'clsx';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import format from '../../utilities/FormattingUtilities';
import MapProperty from './rows/MapProperty';
import PropertiesIpAddressList from './PropertiesIpAddressList';
import PropertiesSiteList from './PropertiesSiteList';
import PropertiesStringList from './PropertiesStringList';
import { PageLink } from '../links/Links';

export const ROW_TYPES = {
    TEXT: 'String',
    MAP: 'Map',
    FUNCTION: 'Function',
};

export const usePropertyStyles = makeStyles({
    title: {
        width: 110,
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
        height: 8,
        border: 'none',
        margin: 0,
        padding: 5,
    },
    func: {
        border: 'none',
        margin: 0,
        padding: 5,
    },
    text: {
        height: 8,
        border: 'none',
        margin: 0,
        padding: 5,
    },
    map: {
        width: 300,
        height: 300,
    },
});

const getValue = (data, item) => {
    const { selector, formatter } = item;
    const rawValue = _.get(data, selector);

    if (formatter) {
        if (_.isFunction(formatter)) {
            return formatter(rawValue);
        }

        return format(rawValue, _.isString(formatter) ? { type: formatter } : formatter);
    }

    return rawValue;
};

function getRows(propertiesDef, data) {
    return propertiesDef.properties.map((item) => {
        return {
            ...item,
            value: getValue(data, item),
        };
    });
}

function TextProperty({ row, classes }) {
    return (
        <TableCell align="left" className={classes.text}>
            {row.value}
        </TableCell>
    );
}

function FunctionProperty({ row, classes, data }) {
    return (
        <TableCell align="left" className={classes.func}>
            {row.mapper(data)}
        </TableCell>
    );
}

function getPropertyView(row, classes, data) {
    switch (row.type) {
        case ROW_TYPES.MAP:
            return <MapProperty row={row} data={data} classes={classes} />;
        case ROW_TYPES.FUNCTION:
            return <FunctionProperty row={row} data={data} classes={classes} />;
        default:
            return <TextProperty row={row} data={data} classes={classes} />;
    }
}

const valuePresent = (row, data) => {
    const func = row.hasValue || (() => true);
    return func(data);
};

export function renderIpAddrList(value) {
    return <PropertiesIpAddressList value={value} />;
}

export function renderPageLink(page, value, filters, excludedFilters) {
    return <PageLink target={page} targetName={value} filters={filters} excludedFilters={excludedFilters} />;
}

export function renderSiteList(value, filters, excludedFilters) {
    return <PropertiesSiteList value={value} excludedFilters={excludedFilters} />;
}

export function renderStringList(value, selector) {
    return <PropertiesStringList value={value} selector={selector} />;
}

export default function Properties({ propertiesDef, data }) {
    const classes = usePropertyStyles();
    const rows = getRows(propertiesDef, data);
    return (
        <TableContainer size="small">
            <Table aria-label="properties table">
                <TableBody>
                    {rows
                        .filter((row) => valuePresent(row, data))
                        .map((row, idx) => (
                            <TableRow key={idx}>
                                <TableCell className={clsx(classes.title, row.className)} component="th" scope="row">
                                    {row.title}
                                </TableCell>
                                {getPropertyView(row, classes, data)}
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
